import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import styles from './Register.module.css';

const VerificarCorreo = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [estado, setEstado] = useState('verificando'); 
    const [mensaje, setMensaje] = useState('');
    const [yaVerificado, setYaVerificado] = useState(false); 
    
    useEffect(() => {
        const token = searchParams.get('token');
        
        if (!token) {
            setEstado('error');
            setMensaje('Token de verificación no válido');
            return;
        }
        
        // Solo verificar si no hemos verificado ya
        if (!yaVerificado) {
            setYaVerificado(true);
            verificarCorreo(token);
        }
    }, [searchParams, yaVerificado]); 
    
    const verificarCorreo = async (token) => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/auth/verificar-correo/${token}`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
        
            
            // Verificar si la respuesta es JSON válida
            const textResponse = await response.text();
            
            let data;
            try {
                data = JSON.parse(textResponse);
            } catch (parseError) {
                console.error('Error parsing JSON:', parseError);
                throw new Error('Respuesta del servidor no válida');
            }
            
            if (response.ok) {
                setEstado('exito');
                setMensaje(data.message);
                
                // Auto-redirección después de 3 segundos
                setTimeout(() => {
                    navigate('/signin');
                }, 3000);
            } else {
                setEstado('error');
                setMensaje(data.error || 'Error al verificar el correo');
            }
        } catch (error) {
            console.error('Error de red:', error);
            setEstado('error');
            setMensaje('Error de conexión con el servidor. Por favor, intenta nuevamente.');
        }
    };
    
    const irALogin = () => {
        navigate('/signin');
    };
    
    const reenviarVerificacion = () => {
        // Opción para reenviar el correo si es necesario
        navigate('/reenviar-verificacion');
    };
    
    return (
        <div className={styles.verificarContainer}>
            <div className={styles.verificarCard}>
                <div className={styles.iconContainer}>
                    {estado === 'verificando' && (
                        <div className={styles.spinner}></div>
                    )}
                    {estado === 'exito' && (
                        <div className={styles.iconExito}>✓</div>
                    )}
                    {estado === 'error' && (
                        <div className={styles.iconError}>✗</div>
                    )}
                </div>
                
                <h2 className={styles.titulo}>
                    {estado === 'verificando' && 'Verificando correo...'}
                    {estado === 'exito' && '¡Correo verificado!'}
                    {estado === 'error' && 'Error de verificación'}
                </h2>
                
                <p className={styles.mensaje}>{mensaje}</p>
                
                {estado === 'exito' && (
                    <p className={styles.redireccion}>
                        Serás redirigido al login en unos segundos...
                    </p>
                )}
                
                <div className={styles.botonesContainer}>
                    {estado !== 'verificando' && (
                        <button 
                            className={styles.botonLogin}
                            onClick={irALogin}
                        >
                            Ir al login
                        </button>
                    )}
                    
                    {estado === 'error' && (
                        <button 
                            className={styles.botonSecundario}
                            onClick={reenviarVerificacion}
                        >
                            Reenviar verificación
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerificarCorreo;